import { useLingui } from "@lingui/react/macro";
import { Anchor, Table, Text } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading";
import { DocImage } from "@/components/docs/DocImage";
import { DocsContent } from "@/components/docs/DocsContent";
import prevSearchEn from "@/docs/images/property-search/previous-searches.en.webp";
import prevSearchSv from "@/docs/images/property-search/previous-searches.sv.webp";

export const Route = createFileRoute("/docs/property-search/previous-searches")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { t } = useLingui();

  const rows: Array<[string, string]> = [
    [t`Project`, t`The project number and name associated with the search`],
    [t`Searched`, t`When the search was performed`],
    [
      t`Properties`,
      t`The designations of the properties that were included in the search`,
    ],
    [
      t`Datasets`,
      t`The datasets that were included in the search. Hover over the icons to see the dataset names`,
    ],
  ];

  return (
    <DocsContent>
      <DocHeading order={1} size="h2">
        {t`Previous searches`}
      </DocHeading>

      <Text>
        {t`In the bottom of the `}
        <Anchor href="/property/search">{t`Property Search`}</Anchor>
        {t` page you can find your previous property searches. The table below provides a summary of the columns in your previous property searches. table`}
      </Text>

      <Table maw="900px">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t`Column name`}</Table.Th>
            <Table.Th>{t`Description`}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map(([type, usage]) => (
            <Table.Tr key={type}>
              <Table.Td>{type}</Table.Td>
              <Table.Td>{usage}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>

      <Text>{t`Click a previous search to quickly return to the Property Search page, where you can view or re-export the data. Search results are cached for 14 days, so returning to the same search during this period does not
       trigger a new data request to Lantmäteriet and is free of charge.`}</Text>

      <DocImage
        src={{ sv: prevSearchSv, en: prevSearchEn }}
        alt={t`Property search overview`}
      />
    </DocsContent>
  );
}
